var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValuecardBackgroundBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 403,
    height: 214,
    viewBox: "0 0 403 214",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C0 0 0 114.968 201.5 114.968C403 114.968 403 0 403 0V214H0V0Z",
    fill: "#35446B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValuecardBackgroundBlue);
export default __webpack_public_path__ + "static/media/valuecard-background-blue.eefda1ed5dbe8350a6f63764eb14fac4.svg";
export { ForwardRef as ReactComponent };